import { F as t } from "./featureText-e2973bdc.mjs";
import "react/jsx-runtime";
import "./index-6a632112.mjs";
import "react";
import "./themes-5f0b3c3d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./superScript-393c70dc.mjs";
import "./hTag-40b23797.mjs";
const x = t, F = t;
export {
  x as FeatureText,
  F as SectionHeader
};
